module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "d904":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "SimpleOtpInput", function() { return /* reexport */ SimpleOtpInput; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./src/components/SimpleOtpInput.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BACKSPACE = "Backspace";
var DELETE = "Delete";
var LEFT_ARROW = "ArrowLeft";
var RIGHT_ARROW = "ArrowRight";
var UP_ARROW = "ArrowUp";
var DOWN_ARROW = "ArrowDown";
var SHIFT = "Shift";
var CTRL = "Ctrl";
var ALT = "Alt";
var TAB = "Tab";
var ENTER = "Enter";
var CMD_CODE = 91;
var OS_CODE = 224;
var UNDEFINED_CODE = 229;

var _isAndroidChrome = function isAndroidChrome() {
  return /chrome/i.test(window.navigator.userAgent) && /android/i.test(window.navigator.userAgent);
};

var isIosDevice = function isIosDevice() {
  return /iPad|iPhone|iPod/.test(window.navigator.userAgent);
};

var buildOtpCodeArr = function buildOtpCodeArr(strVal, len) {
  var emptyVal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  return (// fill all then slice later
    Array.from(strVal).concat(new Array(len).fill(emptyVal)).slice(0, len) // strVal accepts space, but otpCode doesn't
    .map(function (n) {
      return n === " " ? emptyVal : n;
    })
  );
};

/* harmony default export */ var SimpleOtpInput = ({
  name: "SimpleOtpInput",
  emits: ["input", "change", "complete"],
  props: {
    length: {
      type: Number,
      default: 6
    },
    value: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    inputClasses: {
      type: [String, Array, Object],
      default: undefined
    },
    inputProps: {
      type: Object,
      default: undefined
    },
    pasteDelayMs: {
      type: Number,
      default: 0
    },
    withWebOtp: {
      type: Boolean,
      default: false
    },
    withExtraSpan: {
      type: Boolean,
      default: false
    },
    withFocusGrabber: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      otp: buildOtpCodeArr(this.value, this.length, this.emptyValue),
      lastKey: null,
      ac: null,
      shouldFakeFocus: false,
      timeoutIds: []
    };
  },
  computed: {
    isAndroidChrome: function isAndroidChrome() {
      return _isAndroidChrome();
    },
    shouldEnableFocusGrabber: function shouldEnableFocusGrabber() {
      return this.withFocusGrabber || isIosDevice();
    },
    emptyValue: function emptyValue() {
      return this.isAndroidChrome ? " " : "";
    },
    otpValue: function otpValue() {
      return this.otp.map(function (item) {
        return item || " ";
      }).join("");
    },
    isEmpty: function isEmpty() {
      return !this.otpValue.trim();
    },
    lastFocusable: function lastFocusable() {
      for (var idx = this.length; idx > 0; idx--) {
        // empty cell may be a 'space' now, so check it carefully
        var value = this.otp[idx - 1];

        if (value && value.trim()) {
          return idx;
        }
      }

      return 0;
    },
    typeAttrs: function typeAttrs() {
      if (this.type !== "number") {
        return {
          type: this.type
        };
      }

      if (this.isAndroidChrome) {
        return {
          type: "text",
          inputmode: "tel",
          pattern: "[ 0-9]*"
        };
      }

      return {
        type: "number",
        inputmode: "numeric"
      };
    },
    inputAttrs: function inputAttrs() {
      return _objectSpread(_objectSpread({}, this.typeAttrs), this.inputProps);
    }
  },
  mounted: function mounted() {
    if (!this.value) {
      this.setupSmsOtp();
    }
  },
  destroyed: function destroyed() {
    this.timeoutIds.forEach(function (timeoutId) {
      // clear all queued tasks
      clearTimeout(timeoutId);
    });
  },
  watch: {
    value: function value(val) {
      if (val !== this.otpValue) {
        this.otp = buildOtpCodeArr(val, this.length, this.emptyValue);
      }
    }
  },
  methods: {
    setupSmsOtp: function setupSmsOtp() {
      var _this = this;

      // listen for Chrome SMS Otp API
      if (!this.withWebOtp || !("OTPCredential" in window)) {
        return;
      }

      this.ac = new AbortController();
      navigator.credentials.get({
        otp: {
          transport: ["sms"]
        },
        signal: this.ac.signal
      }).then(function (otp) {
        _this.setOtpValue(otp.code);
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this.ac = null;
      });
    },
    enqueueTask: function enqueueTask(fn, delayMs) {
      var timeoutId = setTimeout(fn, delayMs); // track the id

      this.timeoutIds.push(timeoutId);
    },
    emitChange: function emitChange() {
      // this give user a better change recognition
      this.$emit("change", this.otpValue); // mimicking to support v-model

      this.$emit("input", this.otpValue);
    },
    emitComplete: function emitComplete() {
      this.$emit("complete", this.otpValue);

      if (this.ac) {
        this.ac.abort();
      }
    },
    emitEvents: function emitEvents(idx, deleting) {
      this.emitChange();

      if (!deleting && idx === this.length - 1) {
        // emit events on last index if not deleting
        this.emitComplete();
      }
    },
    focusInput: function focusInput(idx) {
      // some browsers do `focus` on `select`, but we call both for certainity
      this.$refs.inputs[idx].focus(); // this.$refs.inputs[idx].select();
    },
    setFakeFocus: function setFakeFocus() {
      this.shouldFakeFocus = true;
    },
    unsetFakeFocus: function unsetFakeFocus() {
      this.shouldFakeFocus = false;
    },
    getOtpValue: function getOtpValue() {
      return this.otpValue;
    },

    /**
     * Set multiple OTP input value sequentially, auto focus on last reachable input.
     * Use this inside keyup with single input may prevent LEFT_ARROW, BACKSPACE to take effect
     */
    setOtpValue: function setOtpValue(data) {
      var startIdx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (!data) {
        return;
      }

      if (this.shouldEnableFocusGrabber) {
        // reset hiddenInput
        this.$refs.hiddenInput.value = "";
      } // Focus on startIdx


      this.focusInput(startIdx);
      this.populateNext(data, startIdx);
    },
    populateNext: function populateNext(data, idx) {
      var _this2 = this;

      // set the value to model and element as well
      this.$refs.inputs[idx].value = data[0];
      this.$set(this.otp, idx, data[0]);
      data = data.substring(1); // Emit change each input update

      this.emitEvents(idx);

      if (idx < this.length - 1) {
        // Not the last input, then focus to next input
        this.focusInput(idx + 1);

        if (data.length) {
          this.enqueueTask(function () {
            // Update next input with the data
            _this2.populateNext(data, idx + 1);
          }, this.pasteDelayMs);
        }
      }
    },
    childFocus: function childFocus(event, idx) {
      if (this.shouldEnableFocusGrabber && event.target !== this.$refs.hiddenInput) {
        // reset hidden input
        this.$refs.hiddenInput.value = "";
      }

      if (idx > this.lastFocusable) {
        this.focusInput(this.lastFocusable);
      } else {
        // select input content
        this.$refs.inputs[idx].select();
      }
    },
    childKeyUp: function childKeyUp(event, idx) {
      var keyCode = event.keyCode,
          key = event.key;

      if ( // Ignore system modifiers keys
      key === SHIFT || key === TAB || key === ALT || key === CTRL || keyCode === CMD_CODE || keyCode === OS_CODE || keyCode === UNDEFINED_CODE || // ignore default keys for number input
      key === UP_ARROW || key === DOWN_ARROW) {
        return;
      }

      if (key === ENTER) {
        // complete on Enter
        this.emitComplete();
      }

      var value = event.target.value.trim();
      var count = value.length;

      if (!this.isAndroidChrome && (key === BACKSPACE || key === DELETE)) {
        // for browser other than Android Chrome, we receive backspaces event
        // keyup is after `input`, so we couldn't know prev value
        if (count) {
          this.$set(this.otp, idx, this.emptyValue); // Emit the change

          this.emitChange(idx);
        }

        if (key === this.lastKey && idx > 0) {
          // back to previous field if repeated
          this.focusInput(idx - 1);
        }
      }

      if (key === LEFT_ARROW && idx > 0) {
        // Left arrow, go to the previous field.
        this.focusInput(idx - 1);
      } else if (key === RIGHT_ARROW && idx < this.length - 1) {
        // Right arrow, go to the next field.
        this.focusInput(idx + 1);
      } else if (key !== BACKSPACE && key !== DELETE && key !== LEFT_ARROW && count === 1 && idx < this.length - 1) {
        this.focusInput(idx + 1);
      }

      this.lastKey = key;
    },
    childBeforeInput: function childBeforeInput(event, idx) {
      var _this3 = this;

      // XXX This happens before the change on `@input`, so the value hasn't been updated
      // fallback for keyUp on Android Chrome, hopefully can handle backspaces better
      if (!this.isAndroidChrome) {
        return;
      }

      var inputType = event.inputType;

      if (inputType === "deleteContentBackward") {
        // We will do the deletion here, by inserting a space,
        // to avoid empty content, which makes Chrome failed to fire next events,
        // prevent the default behaviour, except the first input
        var emptyValue = idx === 0 ? "" : this.emptyValue;
        this.$set(this.otp, idx, emptyValue); // Emit the change

        this.emitChange(idx, true);

        if (idx > 0) {
          // XXX we should only go back to previous field if repeated
          // But Chrome won't give us, because input didn't change
          this.enqueueTask(function () {
            // make sure we did not double delete, because of next `@input`
            _this3.focusInput(idx - 1);
          }, 0);
        }
      }

      this.lastInputType = inputType;
    },
    childPaste: function childPaste(event, idx) {
      event.preventDefault();
      var value = event.clipboardData.getData("text/plain"); // set multiple value with effects

      this.setOtpValue(value, idx);
    },
    childInput: function childInput(event, idx) {
      var _this4 = this;

      var value = event.target.value.trim();
      var count = value.length; // If the target is populated too quickly, count can be > 1

      if (count > 1) {
        // set multiple value with effects
        this.setOtpValue(value, idx);
      } else {
        // update single value
        this.$set(this.otp, idx, value || this.emptyValue); // Emit change for this

        this.emitEvents(idx, !count);

        if (this.shouldEnableFocusGrabber && idx === 0 && this.isEmpty) {
          this.enqueueTask(function () {
            // force user to re-focus on hidden input to get auto suggestion
            if (_this4.isEmpty) {
              _this4.$refs.inputs[0].blur();
            }
          }, 1500);
        }
      }
    }
  },
  render: function render() {
    var _this5 = this;

    var h = arguments[0];
    var _this$$props = this.$props,
        length = _this$$props.length,
        inputClasses = _this$$props.inputClasses,
        withExtraSpan = _this$$props.withExtraSpan;
    var extra = this.$scopedSlots.extra;
    var _this$$data = this.$data,
        otp = _this$$data.otp,
        shouldFakeFocus = _this$$data.shouldFakeFocus;
    var isEmpty = this.isEmpty,
        shouldEnableFocusGrabber = this.shouldEnableFocusGrabber,
        lastFocusable = this.lastFocusable;
    return h("div", {
      "class": ["simple-otp-input", {
        empty: isEmpty
      }]
    }, [otp.map(function (number, idx) {
      return h("div", {
        "key": idx,
        "class": "single-input-container"
      }, [h("input", {
        "ref": "inputs",
        "refInFor": true,
        "domProps": {
          "value": number
        },
        "attrs": _objectSpread(_objectSpread({
          "autocomplete": idx === 0 ? "one-time-code" : "off"
        }, _this5.inputAttrs), {}, {
          "data-testid": "otp-single-input-".concat(idx)
        }),
        "class": ["otp-single-input", {
          active: shouldFakeFocus && idx === lastFocusable
        }, inputClasses],
        "on": {
          "focus": function focus(event) {
            return _this5.childFocus(event, idx);
          },
          "keyup": function keyup(event) {
            return _this5.childKeyUp(event, idx);
          },
          "paste": function paste(event) {
            return _this5.childPaste(event, idx);
          },
          "input": function input(event) {
            return _this5.childInput(event, idx);
          },
          "beforeinput": function beforeinput(event) {
            return _this5.childBeforeInput(event, idx);
          }
        }
      }), extra ? extra({
        otp: otp,
        idx: idx,
        length: length
      }) : withExtraSpan && h("span", {
        "class": "extra-span"
      })]);
    }), shouldEnableFocusGrabber && h("input", {
      "ref": "hiddenInput",
      "class": "hidden-otp-input",
      "attrs": _objectSpread({
        "autocomplete": "one-time-code"
      }, this.inputAttrs),
      "on": {
        "focus": this.setFakeFocus,
        "blur": this.unsetFakeFocus,
        "keyup": function keyup(event) {
          return _this5.childKeyUp(event, 0);
        },
        "paste": function paste(event) {
          return _this5.childPaste(event, 0);
        },
        "input": function input(event) {
          return _this5.childInput(event, 0);
        }
      }
    })]);
  }
});
// EXTERNAL MODULE: ./src/components/SimpleOtpInput.css
var components_SimpleOtpInput = __webpack_require__("d904");

// CONCATENATED MODULE: ./src/libs.js



/* harmony default export */ var libs = (SimpleOtpInput);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (libs);



/***/ })

/******/ });
//# sourceMappingURL=vue-simple-otp-input.common.js.map